<div class="menu-scroll-content">
    <ul class="navigation-menu">
        <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
    </ul>
</div>
